module.exports = __webpack_public_path__ + "fonts/Manrope-500-vietnamese10.d255f9e.woff2";